import AppData from './AppData';
import CalculationHelper from './../components/admin/table_session/helper/CalculationHelper'

export const PickupOrderModeChangeModeMethod = {
    Modal: "Modal",
    Radio: "Radio",
}

// Split into individual [ModeName]::[extraCharge]
const splitToGetPickupOrderModesWithCharge = () => {
    // Expected format
    // 1. No extra charge = [ModeName1],[ModeName2]
    // 2. With extra charge = [ModeName1],[ModeName2]::[extraCharge]
    // 
    // Example
    // Dine In, Take Away::0.20, Premium Package::2
    // Mean we have 3 modes - Dine In, Take Away and Premium Package, where
    // Take Away has extra charge 0.20 and Premium Package has extra charge 2
    let orderModeStr = AppData.data.getMerchantSettingValue('pickup_order_modes') || ""
    if (orderModeStr) {
        orderModeStr = orderModeStr.trim()
    }

    // Split into individual [ModeName]::[extraCharge]
    const pickupOrderModesWithCharge = !orderModeStr ? [] : orderModeStr.split(",").map(function(item) {
        return item.trim()
    })
    return pickupOrderModesWithCharge
}
export default class PickupOrderMode {
    static getPickupOrderModes = () => {
        // Split [ModeName] and [extraCharge] to obtain [ModeName]
        const pickupOrderModesWithCharge = splitToGetPickupOrderModesWithCharge()
        const pickupOrderModes = pickupOrderModesWithCharge.map(item => {
            return item.split("::")[0]
        })
        return pickupOrderModes
    }
    static getPickupOrderModesExtraCharge = (pickupOrderMode) => {
        const pickupOrderModesWithCharge = splitToGetPickupOrderModesWithCharge()
        let extraCharge = 0
        pickupOrderModesWithCharge.find(item => {
            // Split into array [modeName, extraCharge] or if no extra charge will be single element array [modeName]
            const components = item.split("::")
            const pickupOrderModeName = components[0]
            if (pickupOrderModeName === pickupOrderMode) {
                // Round to 2 decimal
                extraCharge = CalculationHelper.round2dp(parseFloat(components[1]))
                return true
            }
        })
        return extraCharge
    }
    static changeModeMethod = () => {
        return AppData.data.getMerchantSettingValue('pickup_order_mode_use_radio_button') == 1 ?
            PickupOrderModeChangeModeMethod.Radio :
            PickupOrderModeChangeModeMethod.Modal
    }
}
